module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_j_piebald.fd253f91.png";